<template>
  <div v-loading="loading" element-loading-text="台账初始化" class="ledger-config-page-template">
    <micro-app class="ledger-config-page-template_micro-app"
               :name="microAppName"
               :url="ledgerFormUrl"
               :baseroute="ledgerFormRoute"
               :data="{ formId, type }"
               :keep-alive="true"
               :disableScopecss="false"
               :disableSandbox="false"
               :shadowDOM="false"
               :inline="false"
               @created="microAppCreated"
               @mounted="microAppMounted"
    />
  </div>
</template>

<script>
import LedgerConfigPageMixins from "@/extend/LedgerConfig/LedgerConfigPageMixins";
export default {
  name: "LedgerConfigPageTemplate",
  mixins: [LedgerConfigPageMixins]
}
</script>

<style lang="scss">
  .ledger-config-page-template {
    position: relative;
    height: 100%;
    .el-drawer__wrapper {
      top: 60px!important;
    }
    .ledger-config-page-template_micro-app {
      height: 100%;
    }
  }
</style>
